module.exports = __webpack_public_path__ + "media/nivel5.946a056d.png";